import {
  fwsApi,
  FWSApiConfig,
  setConfig,
} from '@forwardslashns/fws-api-client';
import {
  coreEntityMissingHandler,
  CoreEntityMissingResponse,
} from './coreEntityMissingHandler';

const config: FWSApiConfig = {
  baseURL: import.meta.env.VITE_BASE_URL,
  withCredentials: true,
};
setConfig(config);

export const isCoreEntityMissingError = (error: unknown): boolean => {
  return !!(
    error &&
    typeof error === 'object' &&
    'response' in error &&
    error.response &&
    typeof error.response === 'object' &&
    'data' in error.response &&
    error.response.data &&
    typeof error.response.data === 'object' &&
    'coreEntityMissing' in error.response.data &&
    error.response.data.coreEntityMissing
  );
};

export type ApiCallOptions = {
  suppressCoreEntityMissing?: boolean;
};

const wrapApiCall = async <T>(
  apiCall: Promise<T>,
  options?: ApiCallOptions
): Promise<T> => {
  try {
    return await apiCall;
  } catch (error) {
    if (
      !options?.suppressCoreEntityMissing &&
      isCoreEntityMissingError(error)
    ) {
      coreEntityMissingHandler(
        (error as { response: { data: CoreEntityMissingResponse } }).response
          .data
      );
    }
    throw error;
  }
};

export type BackendValidationIssue = {
  feature: string;
  message: string;
  affectedFields: string[];
  code: Record<string, unknown>;
  severity: 'warning' | 'error';
};

export const apiClient = {
  get: <T>(url: string, params?: any, options?: ApiCallOptions) =>
    wrapApiCall(fwsApi.get<T>(url, params), options),
  post: <T>(url: string, body?: any, options?: ApiCallOptions) =>
    wrapApiCall(fwsApi.post<T>(url, body), options),
  put: <T>(url: string, body?: any, options?: ApiCallOptions) =>
    wrapApiCall(fwsApi.put<T>(url, body), options),
  del: <T>(url: string, options?: ApiCallOptions) =>
    wrapApiCall(fwsApi.del<T>(url), options),
  patch: <T>(url: string, body?: any, options?: ApiCallOptions) =>
    wrapApiCall(fwsApi.patch<T>(url, body), options),
};
